module.exports = __webpack_public_path__ + "static/media/settings.0bf91957.svg";